import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("sos_token") || localStorage.getItem("sos_admin_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const fmtEUR = (v) =>
    new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR" }).format(Number(v) || 0);

// Multiplica preço sem IVA pela taxa em vigor (default 23% PT).
export const withVAT = (price, vatRate = 23) =>
    Math.round(Number(price || 0) * (1 + Number(vatRate) / 100) * 100) / 100;

// Devolve preço final aplicando campanha (se enviado pelo backend).
export const finalPrice = (product) => {
    if (!product) return 0;
    return Number(product.final_price ?? product.price ?? 0);
};
